<template>
  <b-modal
    id="insert-document-link-modal"
    :title="trans('insert_link_document')"
    :ok-title="trans('insert')"
    :ok-disabled="!url"
    :cancel-title="trans('cancel')"
    @ok="onInsert"
  >
    <b-form-group>
      <b-form-radio-group v-model="mode" :options="modeOptions">
      </b-form-radio-group>
    </b-form-group>
    <div>
      <b-form-group v-if="mode == 'document'">
        <document-dropdown
          ref="dropdown"
          :organization="organization"
          v-model="document_id"
          :initial_short_url="initial_url"
          nullable
          @document="onSelectDocument"
        />
        <div class="text-center">
          <em>{{ trans('or') }}</em>
        </div>
        <b-form-group :label="trans('upload')">
          <b-form-file
            v-model="upload_file"
            :placeholder="trans(organization.allow_non_pdf_document_upload ? 'upload_document' : 'upload_pdf')"
            :drop-placeholder="trans('drop_file_here')"
            :accept="organization.allow_non_pdf_document_upload ? '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx' : 'application/pdf'"
            :disabled="busy"
            @input="onDocumentFileChange(null)"
          />
        </b-form-group>
      </b-form-group>
      <b-form-group v-if="mode == 'page'">
        <page-dropdown
          :organization="organization"
          v-model="page_id"
          :initial_short_url="initial_url"
          nullable
          @page="onSelectPage"
          :disabled="busy"
        ></page-dropdown>
      </b-form-group>
    </div>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('uploading') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>
<script>
  import DocumentDropdown from './../media/DocumentDropdown'
  import PageDropdown from './../page/PageDropdown'

  export default {
    props: {
      organization: Object,
      initial_url: String,
      value: String,
    },
    components: {
      DocumentDropdown,
      PageDropdown,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        url: null,
        mode: 'document',
        modeOptions: _.compact([
          {text: trans('document'), value: 'document'},
          {text: trans('page'), value: 'page'},
        ]),
        document: null,
        document_id: null,
        upload_file: null,
        page_id: null,
      }
    },
    methods: {
      onDocumentFileChange() {
        if (!this.upload_file) return
        const url = `/organization/${this.organization.id}/media/document`
        this.busy = true
        this.error = null
        let formData = new FormData();
        formData.append("file", this.upload_file);
        axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.document = response.data
          this.document_id = this.document.id
          this.url = this.document.short_url
          setTimeout(() => {
            this.$refs.dropdown.refresh()
            this.upload_file = null
            this.busy = false
            this.onInsert()
          }, 100)
        })
        .catch(this.handleError)
      },
      onSelectDocument(doc) {
        if (this.page_id) this.page_id = null
        this.url = doc ? doc.short_url : null
        this.document = doc
      },
      onSelectPage(page) {
        if (this.document_id) this.document_id = null
        this.url = page ? page.short_url : null
        this.page = page
      },
      onInsert() {
        this.$emit('input', this.url)
        if (this.document) this.$emit('document', this.document)
        if (this.page) this.$emit('page', this.page)
        this.$bvModal.hide('insert-form-document-link-modal')
      },
    },
    mounted() {
      window.insertDocumentLinkModal = this
    },
  }
</script>